import {
  HTTP_UPDATESPECIAL_FETCHING,
  HTTP_UPDATESPECIAL_SUCCESS,
  HTTP_UPDATESPECIAL_FAILED,
  server,
  OK,
  YES,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";

//Update Special
export const setStateupdateSpecialToFetching = () => ({
  type: HTTP_UPDATESPECIAL_FETCHING,
});

export const setStateupdateSpecialToSuccess = (payload) => ({
  type: HTTP_UPDATESPECIAL_SUCCESS,
  payload,
});

export const setStateupdateSpecialToFailed = (payload) => ({
  type: HTTP_UPDATESPECIAL_FAILED,
});

export const updateBudgetOById = (budgetoid, memid, item) => {
  return async (dispatch) => {
    dispatch(setStateupdateSpecialToFetching());
    try {
      await httpClient.put(
        `${server.UPDATESPECIAL_URL}/${budgetoid}/${memid}`,
        item
      );
      dispatch(setStateupdateSpecialToSuccess("success"));
    } catch (error) {
      dispatch(setStateupdateSpecialToFailed());
    }
  };
};
